const styles = theme => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(2),
  },
  containerClient: {
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.up('md')]: {
      flexDirection: 'row',
    },
  },
  table: {
    flex: 1,
    paddingBottom: theme.spacing(2),
    [theme.breakpoints.up('md')]: {
      paddingBottom: theme.spacing(0),
      paddingRight: theme.spacing(2),
    },
  },
  detail: {
    [theme.breakpoints.up('md')]: {
      maxWidth: '400px',
    },
  },
})

export default styles
